import { Flex } from '@zillow/constellation';
import styled from 'styled-components';

export const StyledImageThumbnailGrid = styled(Flex)`
  flex-wrap: wrap;
  gap: 4px;
  max-width: 192px;
  position: relative;

  @media screen and (min-width: 366px) {
    max-width: 290px;
  }
`;
